import type { SavedConfigType } from "../types/SaveTypes";
import type { ExternalConfigType } from "../types/ExternalPriceType";
import Debug from "../../../common-deprecated/Debug";

export const configureCtxConfig = (savedConfig: SavedConfigType): void => {
    if (!window.T1) window.T1 = { settings: {} };
    if (!window.T1.ctx) window.T1.ctx = {};
    window.T1.ctx.config = savedConfig;
};

export const fetchCCSaveFinancePayload = async (
    loadSaveServer: string,
    config: ExternalConfigType,
): Promise<ExternalConfigType | null> => {
    try {
        // Make a request to the CCSave API to get the finance response
        const fallbackGateway = `${loadSaveServer}/config/find/json/finance`;

        const ccSaveResponse = await fetch(fallbackGateway, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(config),
            mode: "cors",
        });

        const savingConfig = await ccSaveResponse.json();

        return savingConfig;
    } catch (error) {
        Debug.error("Failed to get Finance configuration from CCSave");
        return null;
    }
};

export const fetchCCSave = async (
    loadSaveServer: string,
    config: ExternalConfigType,
): Promise<SavedConfigType | null> => {
    try {
        const fallbackGateway = `${loadSaveServer}/config/find/json/legacy`;

        const ccSaveResponse = await fetch(fallbackGateway, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(config),
            mode: "cors",
        });

        if (!ccSaveResponse.ok) throw new Error(`CCSave fetch failed: ${ccSaveResponse.status}`);

        const savingConfig = await ccSaveResponse.json();

        return savingConfig;
    } catch (error) {
        Debug.error("Failed to get configuration from CCSave", error);
        return null;
    }
};
